import { UPCOMING_EVENTS, UPCOMING_EVENTS_ERROR, UPCOMING_EVENTS_HIDE_ERROR, UPCOMING_EVENTS_START_LOADER, UPCOMING_EVENTS_STOP_LOADER, } from "../interface/IUpcomingEvents";
const initState = {
    data: {},
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const UpcomingEventsReducer = (state = initState, action) => {
    switch (action.type) {
        case UPCOMING_EVENTS: {
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        }
        case UPCOMING_EVENTS_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case UPCOMING_EVENTS_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case UPCOMING_EVENTS_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case UPCOMING_EVENTS_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default UpcomingEventsReducer;
